window.Reverb = window.Reverb || {};

Reverb.Animations = (function () {
  function init() {
    $('.animate-on-load').addClass('run-animation');
  }

  return {
    init,
  };
}());

$(Reverb.Animations.init);



// WEBPACK FOOTER //
// ./src/components/legacy/animations.js